import { render } from "./CustomerRegistration.vue?vue&type=template&id=445cc220&scoped=true&ts=true"
import script from "./CustomerRegistration.vue?vue&type=script&lang=ts"
export * from "./CustomerRegistration.vue?vue&type=script&lang=ts"

import "./CustomerRegistration.vue?vue&type=style&index=0&id=445cc220&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445cc220"]])

export default __exports__